// @flow
import CopyFrom from './CopyFrom';

export default CopyFrom;
